module.exports = __webpack_public_path__ + "static/carwash-8381a8709dbcfa859345225c78bf9e0e.m4a";